import React from 'react';

const FormCreate = (props) => {
  return (
    <>
      <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
        <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
        <div className="modal-container bg-white w-11/12 md:max-w-xl mx-auto rounded shadow-lg z-50 overflow-y-auto">
          <div className="modal-content items-center p-6 text-left">
            <div className="flex mb-4">
              <h4>Ongkos kirim</h4>
              <button className="px-2 ml-auto" onClick={props.handdleClick}>
                X
              </button>
            </div>
            <div className="flex mb-4 w-full overflow-y-auto">
              <div className="flex flex-col w-6/12 px-2">
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Area</span>
                  <select class="form-select mt-1 block w-full">
                    <option>Pilih kota</option>
                    <option>Malang</option>
                    <option>Surabaya</option>
                  </select>
                </label>
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Tarif</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1 "
                    placeholder="Masukkan tarif"
                  ></input>
                </label>
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Tarif / Km</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1"
                    placeholder="Masukkan tarif / km"
                  ></input>
                </label>
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Diskon</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1"
                    placeholder="Masukkan diskon"
                  ></input>
                </label>
              </div>
              <div className="flex flex-col w-6/12 px-2">
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Minimum order</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1"
                    placeholder="Masukkan minimum order"
                  ></input>
                </label>
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Tanggal Mulai</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1"
                    placeholder="Masukkan mulai aktif"
                  ></input>
                </label>
                <label class="mt-4">
                  <span class="text-gray-700 font-bold">Tanggal Berakhir</span>
                  <input
                    type="email"
                    class="form-input w-full mt-1"
                    placeholder="Masukkan mulai berakhir aktif"
                  ></input>
                </label>
              </div>
            </div>
            <button
              onClick={props.handdleClick}
              className="bg-green-100 w-3/12 text-white rounded px-4 py-3 capitalize text-center mt-8"
            >
              Tambah
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCreate;
